'use strict';

// Child-friendly passphrases, Word-Word-Word-N (e.g. Purple-Tiger-Moon-7), for the
// "Generate a passphrase" button (ST4S A2, R5). Randomness comes from crypto.getRandomValues
// (reaching Elm through the onPassphraseGenerated port), never Elm's time-seeded Random.
// Three capitalised words, '-' (a Cognito symbol) and a digit give all four classes; a result
// shorter than 14 characters is regenerated.

const { PASSPHRASE_WORDS } = require('./passphraseWords');
const { isPasswordBreached } = require('./breachCheck');

const PASSPHRASE_MIN_LENGTH = 14;

const cryptoRandomUint32 = () => {
    const values = new Uint32Array(1);
    crypto.getRandomValues(values);
    return values[0];
};

// Uniform in [0, n): rejection sampling avoids modulo bias.
const randomBelow = (n, randomUint32) => {
    const limit = Math.floor(0x100000000 / n) * n;
    let x;
    do {
        x = randomUint32();
    } while (x >= limit);
    return x % n;
};

const capitalise = (word) => word.charAt(0).toUpperCase() + word.slice(1);

const generatePassphrase = (randomUint32 = cryptoRandomUint32, words = PASSPHRASE_WORDS) => {
    for (;;) {
        const parts = [0, 1, 2].map(() => capitalise(words[randomBelow(words.length, randomUint32)]));
        const passphrase = parts.join('-') + '-' + randomBelow(10, randomUint32);
        if (passphrase.length >= PASSPHRASE_MIN_LENGTH) {
            return passphrase;
        }
    }
};

// A passphrase not known to HIBP, regenerating on a hit (bounded: the server re-checks anyway).
const generateSafePassphrase = async (options = {}) => {
    const randomUint32 = options.randomUint32 || cryptoRandomUint32;
    const isBreached = options.isBreached || isPasswordBreached;
    const maxAttempts = options.maxAttempts || 5;
    let passphrase = generatePassphrase(randomUint32, options.words);
    for (let attempt = 1; attempt < maxAttempts && await isBreached(passphrase); attempt++) {
        passphrase = generatePassphrase(randomUint32, options.words);
    }
    return passphrase;
};

module.exports = { PASSPHRASE_MIN_LENGTH, cryptoRandomUint32, randomBelow, generatePassphrase, generateSafePassphrase };
